export default __webpack_public_path__ + "static/media/ZA.72668a40.ico";